import { ConfigProvider } from 'antd'
import { BrowserRouter as BrowserRouterComponent } from 'react-router-dom'
import Routes from './routes'
import { AppCountry, AppLanguage, AppShowType } from '@/constants/app.constant'
import TransactionDetail from '@/pages/TransactionDetail'
import { useMemo } from 'react'
import { Provider } from 'react-redux'
import { StoreContext } from 'redux-react-hook'
import store from './pages/Order/redux/store'
import { AppProvider } from './context/app'
import type { AppProps } from './interface'

import enUS from 'antd/lib/locale/en_US'
import idID from 'antd/lib/locale/id_ID'
import msMY from 'antd/lib/locale/ms_MY'
import zhCN from 'antd/lib/locale/zh_CN'
import viVN from 'antd/lib/locale/vi_VN'
import thTH from 'antd/lib/locale/th_TH'
import type { Locale } from 'antd/lib/locale-provider'

const BrowserRouter = BrowserRouterComponent as any

const antdLocaleMap: Record<string, Locale> = {
  en: enUS,
  id: idID,
  'ms-my': msMY,
  'zh-Hans': zhCN,
  vi: viVN,
  th: thTH,
}

function App(props: Partial<AppProps> & { appBridgeData: Window['bridgeData'] }) {
  const { appBridgeData } = props
  const { data, showType, onClose } = appBridgeData

  const userId = `${data?.user?.userId || ''}`
  const merchantId = data?.user?.merchantId ?? 0

  const { PREFIXCLS, PREFIXCLS_ICON } = process.env

  // NOTE: 解决 单独访问子应用时 message 显示问题
  ConfigProvider.config({ prefixCls: PREFIXCLS })

  const memoAppChildren = useMemo(() => {
    // TODO: 根据showType判断是页面还是弹窗，本期只有一个弹窗暂时先写死，后期需主应用传对应的弹窗标识做分发
    if (showType === AppShowType.Modal) {
      return <TransactionDetail onClose={onClose} {...data?.props} />
    }

    if (!AppCountry.isVn) {
      return (
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      )
    }

    // VN 的 Order 模块依赖 Redux
    return (
      <Provider store={store}>
        <StoreContext.Provider value={store}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </StoreContext.Provider>
      </Provider>
    )
  }, [data?.props, onClose, showType])

  return (
    <AppProvider {...data?.props} userId={userId} merchantId={merchantId}>
      <ConfigProvider
        prefixCls={PREFIXCLS}
        iconPrefixCls={PREFIXCLS_ICON}
        locale={antdLocaleMap[AppLanguage.current] || enUS}
      >
        {memoAppChildren}
      </ConfigProvider>
    </AppProvider>
  )
}

export default App
